import { axios } from '../../../plugins/axios'

const BASE_PATH = '/PoliciaCuadrantes/DesarrolloPolicial'

export default class DesempeñoInstitucionalApiRepository {
  async create(payload, idPersonal) {
    const { data } = await axios.post(BASE_PATH + '/personal/' + idPersonal + '/desempenioInstitucional', payload)

    return data
  }

  async update(payload, idPersonal, idEvaluacion) {
    const { data } = await axios.put(
      BASE_PATH + '/personal/' + idPersonal + '/desempenioInstitucional/' + idEvaluacion,
      payload
    )

    return data
  }

  async updateEstatus(payload, idPersonal, idEvaluacion) {
    const { data } = await axios.put(
      BASE_PATH + '/personal/' + idPersonal + '/desempenioInstitucional/' + idEvaluacion + '/estatus',
      {
        fk_idCatEstatusEvaluacion: payload.fk_idCatEstatusEvaluacion,
      }
    )

    return data
  }

  async findById(payload) {
    const { data } = await axios.get(
      BASE_PATH + '/personal/' + payload.idPersonal + '/desempenioInstitucional/' + payload.idEvaluacion
    )

    return data.data
  }

  async getEvaluationItems() {
    const { data } = await axios.get(BASE_PATH + '/evaluacion/4/reactivosEvaluacion')

    return data.data
  }
}
